import React, { useContext } from "react";
import { Link } from "react-router-dom";
import CustomButton from "../CustomButton";
import { BsArrowLeft } from "react-icons/bs";
import { FiLogOut } from "react-icons/fi";
import { FaPen } from "react-icons/fa";
import { ThemeContext } from "../../ThemeContext/ThemeContext.js";
import {
  PROFILE,
  CUSTOMIZATIONS,
  PAYMENTS,
  FEEDBACK,
  LOGOUT,
} from "../../constants/settingsStrings.js";

import Bottombar from "../Bottombar";
import PersonBlack from "../../assets/Icons/PersonBlack";
import PersonWhite from "../../assets/Icons/PersonWhite";
import PayWhiteIcon from "../../assets/Icons/PayWhiteIcon";
import PayBlackIcon from "../../assets/Icons/PayBlackIcon";
import FeedWhiteIcon from "../../assets/Icons/FeedWhiteIcon";
import FeedBlackIcon from "../../assets/Icons/FeedBlackIcon";
import CustomWhiteIcon from "../../assets/Icons/Customwhiteicon";
import CustomBlackIcon from "../../assets/Icons/CustoBalckIcon";

const accountSettings = [
  {
    id: 2,
    icon1: CustomWhiteIcon,
    icon2: CustomBlackIcon,
    text: CUSTOMIZATIONS,
    link: "/settings/customization",
  },
  {
    id: 3,
    icon1: PayWhiteIcon,
    icon2: PayBlackIcon,
    text: PAYMENTS,
    link: "/settings/payment",
  },
  {
    id: 4,
    icon1: FeedWhiteIcon,
    icon2: FeedBlackIcon,
    text: FEEDBACK,
    link: "/settings/feedback",
  },
  {
    id: 5,
    icon1: FiLogOut,
    icon2: FiLogOut,
    text: LOGOUT,
    link: "/settings/logout",
  },
];

export default function AccountSetting({ active }) {
  const { theme } = useContext(ThemeContext);

  return (
    <>
      <div className=" sm:shadow-md  overflow-hidden sm:flex items-center justify-center  bg-white   rounded-[25px]  dark:bg-[#181818] h-full sm:h-96 px-10 ">
        <div className=" sm:hidden">
          <div className=" w-full  h-32 items-center justify-center flex">
            <div className="border sm:hidden sm:h-[90px] bg-red-900 rounded-[25px] h-[120px] grid place-content-center w-[363px] bg-gradient-to-b items-center from-[#D62723] to-[#2A71E8]  sm:ml-0">
              <div className="flex absolute space-x-[50px]  sm:space-x-[120px] mb-14 sm:hidden">
                <Link to="/">
                  <BsArrowLeft
                    size={24}
                    color="white"
                    className="cursor-pointer ml-2"
                  />
                </Link>
                <h3 className="text-white font-[10px] font-sans ml-[10px]">
                  Account Settings
                </h3>
              </div>
              <div className="items-center">
                <div className="bg-white dark:bg-gray-700 rounded-full w-full h-full sm:mt-4 mt-[100px] border relative border-gray-400 dark:border-gray-600">
                  <img
                    src={require("../../assets/img/profile.png")}
                    alt=""
                    className="px-2 py-2"
                  />
                  <div className="bg-[#D2D2D6] dark:bg-gray-600 rounded-full w-[25px] h-[25px] absolute ml-10 bottom-0.5">
                    <FaPen className="m-2 w-3 grid place-content-center h-3 text-gray-800 dark:text-white" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <h3 className="font-bold mt-10 sm:mt-0 grid place-content-center text-[20px] sm:hidden dark:text-white">
            Andrew .M
          </h3>
        </div>
        <div className="">
          <div className="w-full h-full">
            <div className="">
            <div className="max-sm:hidden">
                <Link to="/settings/profile">
                  <CustomButton
                    id={"edit-profile"}
                    text={"EDIT PROFILE"}
                    Icon={active === "EDIT PROFILE" ? PersonBlack : PersonWhite}
                    active={active}
                  />
                </Link>
              </div>
            <div className="sm:hidden">
                <Link to="/settings/profile/edit">
                  <CustomButton
                    id={"edit-profile"}
                    text={"EDIT PROFILE"}
                    Icon={active === "EDIT PROFILE" ? PersonBlack : PersonWhite}
                    active={active}
                  />
                </Link>
              </div>
              {accountSettings.map(({ id, text, icon1, icon2, link }) => (
                <Link key={id} to={link}>
                  <CustomButton
                    id={id}
                    text={text}
                    Icon={active === text ? icon1 : icon2}
                    active={active}
                  />
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>

      <Bottombar activeBar={'settings'} />
    </>
  );
}
